
import { loadSelect } from '@/api/common.js'
// 加载级联下拉框
export function loadJiGouCascader (data) {
  loadSelect({ url: '/api/v2/xiaoneijigou/tree', data: data, order: 'jgh', sort: 'asc' }) // [url]接口地址 [data]列表
}
// 加载级联下拉框，带校区
export function loadXiaoQuJiGouCascader (data) {
  loadSelect({ url: '/api/v2/xiaoneijigou/tree_xiaoqu', data: data, order: 'jgh', sort: 'asc' }) // [url]接口地址 [data]列表
}
